"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonOptionsInput = void 0;
const React = require("react");
const _ = require("lodash");
const InlineOptions_1 = require("../../atoms/InlineOptions");
const standardizeOptions_1 = require("../../../../helpers/standardizeOptions");
const isValueInOptions_1 = require("../../../../helpers/isValueInOptions");
const TextInput_1 = require("../TextInput");
class ButtonOptionsInput extends React.Component {
    constructor(props) {
        super(props);
        // Toggles one of the values
        this.toggleValue = (v) => {
            if (!Array.isArray(this.state.value)) {
                throw Error("Cannot call toggle value with non array values");
            }
            const value = _.xor(this.state.value, [v]);
            this.setValue(value);
        };
        // Sets the values
        this.setValue = (value) => {
            this.setState({ value });
            this.props.onInputChange(value);
        };
        this.state = {
            value: props.value
        };
        this.options = (0, standardizeOptions_1.standardizeOptions)(this.props.options, this.props.autoOrder);
        // check that allow multiple is used appropriately
        if (props.allowMultiple &&
            props.allowMultiple !== Array.isArray(props.value)) {
            throw new Error("allowMultiple is not consistent with value");
        }
        // Replace any matching objects with the current value to make the comparison
        // a pointer comparison - needed for the validation
        this.options = this.options.map(o => {
            // updates the pointer
            (Array.isArray(props.value) ? props.value : [props.value]).forEach(v => {
                if (_.isEqual(o.value, v)) {
                    o.value = v;
                }
            });
            return o;
        });
        this.name = _.uniqueId("name");
    }
    componentWillReceiveProps(nextProps) {
        // TODO - sanitise the data
        if (_.has(nextProps, "value")) {
            this.setState({ value: nextProps.value });
        }
    }
    render() {
        let allowMultipleDataTag;
        const selectedValueArray = _.isArray(this.state.value)
            ? this.state.value
            : [this.state.value];
        this.props.allowMultiple
            ? (allowMultipleDataTag = "multiple")
            : (allowMultipleDataTag = "single");
        if (!(0, isValueInOptions_1.isValueInOptions)(this.options, this.props.value)) {
            return (React.createElement(TextInput_1.TextInput, { onInputChange: () => { }, disabled: true, value: Array.isArray(this.state.value)
                    ? this.state.value.join(", ")
                    : this.state.value.toString() }));
        }
        return (React.createElement("div", { "data-test": "inline-options", "data-input-type": allowMultipleDataTag },
            React.createElement(InlineOptions_1.default, null, this.options.map(option => {
                const selected = selectedValueArray.indexOf(option.value) > -1;
                const onClick = () => {
                    this.props.allowMultiple
                        ? this.toggleValue(option.value)
                        : this.setValue(option.value);
                };
                return (React.createElement(InlineOptions_1.Option, { key: option.label, selected: selected, disabled: this.props.disabled, onClick: onClick, allowMultiple: this.props.allowMultiple, name: this.name },
                    React.createElement("div", { "data-value": option.label }, option.label)));
            }))));
    }
}
exports.ButtonOptionsInput = ButtonOptionsInput;
//# sourceMappingURL=index.js.map